import React from "react";
import { ContentWithPaddingXl } from "components/misc/Layouts";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro";
import { useTranslation } from "react-i18next";
import BgTitle from "components/title/BgTitle";
import uiImg from "images/itservice/v2/system-dev.avif";
import devImg from "images/itservice/v2/ses-dev.jpg";
import aiImg from "images/itservice/v2/ai.png";
import backendImg from "images/itservice/v2/backend.png";
import wordpressImg from "images/itservice/v2/wordpress.jpg";
import appImg from "images/itservice/v2/app.jpg";
import { Typography, Box } from "@mui/material";

const Posts = tw.div`mt-4 flex flex-wrap -mx-2`;
const PostContainer = styled.div`
  ${tw`mt-4 w-full sm:w-1/2 lg:w-1/5 px-2`}
`;

const Post = styled.div`
  ${tw`flex flex-col bg-gray-100 rounded-lg h-full`}
  border: ${(props) =>
    props.firstCard
      ? "1px solid rgba(12, 77, 150, 0.22)"
      : "1px dashed rgba(12, 77, 150, 0.22)"};
  min-height: 250px; /* Reduced card height */
`;

const ImageContainer = styled.div`
  ${tw`relative overflow-hidden rounded-t-lg`}
  height: 150px; /* Reduced image height */
`;

const Image = styled.div`
  ${(props) =>
    css`
      background-image: url("${props.imageSrc}");
    `}
  ${tw`w-full h-full bg-cover bg-center transition-transform duration-300`}
  &:hover {
    transform: scale(1.05); /* Subtle zoom-in effect */
  }
`;

const HeaderRow = styled.div`
  ${tw`flex justify-between items-center flex-col xl:flex-row border-b-2 border-ncc mb-4`}
  text-align: right;
`;
const Info = tw.div`p-4 bg-[#eeeeee70] flex-1 flex flex-col gap-2`;
const Category = tw.div`text-ncc text-xs font-bold tracking-widest uppercase leading-snug`;
const Title = tw.div`mt-1 font-black text-sm text-gray-900 group-hover:text-ncc transition duration-300`;
const Description = styled.div`
  ${tw`text-gray-700 mt-1`};
  font-size: 0.7rem; /* Reduced font size */
`;

export default ({ headingText = "Our IT Services" }) => {
  const { t } = useTranslation();
  const posts = [
    // {
    //   imageSrc: devImg,
    //   category: t("services.systemDesign.category"),
    //   title: t("services.systemDesign.title"),
    //   description: t("services.systemDesign.description"),
    //   featured: true,
    // },
    {
      imageSrc: uiImg,
      category: t("services.frontendDevelopment.category"),
      title: t("services.frontendDevelopment.title"),
      description: t("services.frontendDevelopment.description"),
    },
    {
      imageSrc: backendImg,
      category: t("services.backendDevelopment.category"),
      title: t("services.backendDevelopment.title"),
      description: t("services.backendDevelopment.description"),
    },
    {
      imageSrc: appImg,
      category: t("services.mobileAppDevelopment.category"),
      title: t("services.mobileAppDevelopment.title"),
      description: t("services.mobileAppDevelopment.description"),
    },
    {
      imageSrc: aiImg,
      category: t("services.aiSolutions.category"),
      title: t("services.aiSolutions.title"),
      description: t("services.aiSolutions.description"),
    },
    {
      imageSrc: wordpressImg,
      category: t("services.wordpressDevelopment.category"),
      title: t("services.wordpressDevelopment.title"),
      description: t("services.wordpressDevelopment.description"),
    },
  ];

  return (
    <ContentWithPaddingXl>
      <Box
        sx={{
          mb: 4,
          mt: -2,
        }}
      >
        <Typography
          sx={{ fontSize: "1rem", fontWeight: 500 }}
          variant="subtitle1"
        >
          {t("services.headerTitle")}
          <br />
          {t("services.headerSubtitle")}
        </Typography>
      </Box>
      <HeaderRow>
        <BgTitle text={t("services.headingText")} />
      </HeaderRow>

      <Posts>
        {posts.map((post, index) => (
          <PostContainer key={index}>
            <Post className="group">
              <ImageContainer>
                <Image imageSrc={post.imageSrc} />
              </ImageContainer>
              <Info>
                <Category>{post.category}</Category>
                <Title>{post.title}</Title>
                {post.description && (
                  <Description>{post.description}</Description>
                )}
              </Info>
            </Post>
          </PostContainer>
        ))}
      </Posts>
    </ContentWithPaddingXl>
  );
};
